import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { GlobalState } from '../../global.state';
import { Subscription } from 'rxjs/Subscription';

import { cancelSubscription } from '../../shared/cancelSubscription';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
  public overlayID = '';
  private subscription1: Subscription;
  @Input() isLogin: boolean;

  constructor(private _state: GlobalState) { }

  ngOnInit(): void {
    this.subscription1 = this._state.mainMenuChanged
      .subscribe(() => {
         if (this.overlayID) {
            this.overlayID = '';
          } else {
            this.overlayID = 'overlay';
          }
      });
  }

  ngOnDestroy(): void {
    cancelSubscription([this.subscription1]);
  }
  public toggleMainMenu(): void {
    this._state.changeMainMenu();
  }
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/core/main/main.component.ts